// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import Route from '@/extend/classes/Route';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Notifications
export default class Notif  {
  // Identifiant unique
  public id: number;
  // Id de la definition notification
  public notifDefId: number;
  // Masque du profil destinataire
  public profil: number;
  // Client destinataire
  public clientId: number;
  // Objet de rattachement
  public owner: Owner;
  // Type de notification
  public type: NotifDefTypes;
  // isRead
  public isRead: boolean;
  // routage associé à la notification
  public route: Route;
  // Titre notif
  public titre: string;
  // Notif label
  public label: string;
  // Notif contexte
  public contexte: string;
  // Notif detail
  public detail: string;
  // Code de la notification
  public code: string;
  // Date de la notification
  public echeance: Date;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.notifDefId = 0;
    this.profil = 0;
    this.clientId = 0;
    this.owner = new Owner();
    this.type = NotifDefTypes.NONE;
    this.isRead = false;
    this.route = new Route();
    this.titre = '';
    this.label = '';
    this.contexte = '';
    this.detail = '';
    this.code = '';
    this.echeance = new Date(1901,1,1,0,0,0,0);
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Notif): Notif {
    const newNotif: Notif = new Notif();
    newNotif.id = obj.id;
    newNotif.notifDefId = obj.notifDefId;
    newNotif.profil = obj.profil;
    newNotif.clientId = obj.clientId;
    newNotif.owner = JSON.parse(JSON.stringify(obj.owner));
    newNotif.type = obj.type;
    newNotif.isRead = obj.isRead;
    newNotif.route = JSON.parse(JSON.stringify(obj.route));
    newNotif.titre = obj.titre;
    newNotif.label = obj.label;
    newNotif.contexte = obj.contexte;
    newNotif.detail = obj.detail;
    newNotif.code = obj.code;
    newNotif.echeance = new Date(obj.echeance);
    newNotif.createId = obj.createId;
    newNotif.failed = obj.failed;
    newNotif.canUpdate = obj.canUpdate;
    newNotif.canDelete = obj.canDelete;
    newNotif.display = obj.display;
    newNotif.ownerType = obj.ownerType;
    newNotif.ownerId = obj.ownerId;
    newNotif.ownerLabel = obj.ownerLabel;
    return newNotif;
  }

  public toJsonNotif (): string {
    const json = {
      notifDefId: this.notifDefId,
      profil: this.profil,
      clientId: this.clientId,
      owner: this.owner,
      type: this.type,
      isRead: this.isRead,
      route: this.route,
      titre: this.titre,
      label: this.label,
      contexte: this.contexte,
      detail: this.detail,
      code: this.code,
      echeance: this.echeance ? new Date (this.echeance).toString() : this.echeance,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
    }
    return JSON.stringify(json);
  }

  public fromNotif (obj: Notif): void {
    this.id = obj.id;
    this.notifDefId = obj.notifDefId;
    this.profil = obj.profil;
    this.clientId = obj.clientId;
    this.owner = obj.owner;
    this.type = obj.type;
    this.isRead = obj.isRead;
    this.route = obj.route;
    this.titre = obj.titre;
    this.label = obj.label;
    this.contexte = obj.contexte;
    this.detail = obj.detail;
    this.code = obj.code;
    this.echeance = new Date(obj.echeance);
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareNotif (value: Notif): boolean {
    return (this.toJsonNotif() == value.toJsonNotif());
  }

  public cloneNotif (): Notif {
    return Notif.fromJson(this);
  }

  public deleteForStoreNotif (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/notifs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreNotif (): Promise<Notif> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/notifs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromNotif(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/notifs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static dialog (notif: Notif): Promise<Notif> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/notifs/dialog', notif, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Notif.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Notifs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Notif.fromJson(listData.reccords[0] as Notif);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Notif> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Notifs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Notif.fromJson(listData.reccords[0] as Notif);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(notifs: Notif[]) {
    notifs.forEach((item) => {
      item.echeance = item.echeance ? new Date(item.echeance) : item.echeance;
    })
  }
}
